import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React from "react";

const RiskToggle = ({ title, value, handleChange, field, data }) => {
  return (
    <Box>
      <Typography variant="body2" fontWeight={500} gutterBottom>
        {title}
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(e, value) => {
          if (value !== null) handleChange(field, value);
        }}
        color="primary"
      >
        {data.map((opt) => (
          <ToggleButton key={opt} value={opt}>
            {opt}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default RiskToggle;
